import { useNavigate, useSearchParams } from 'react-router-dom'

interface ClearFiltersButtonProps {}

export const ClearFiltersButton = ({}: ClearFiltersButtonProps) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const clearParams = () => {
    setSearchParams({})
  }

  return (
    <button
      onClick={clearParams}
      disabled={searchParams.size === 0}
      className={`text-xs md:text-base font-medium text-[#00323D] disabled:text-[#A0ABBE] disabled:cursor-not-allowed`}
    >
      Clear filters
    </button>
  )
}
